import { useCallback } from 'react';
import { useAutomationRuleFormProvider } from 'src/pages/automation-rule/form';
import { actionTypes } from 'src/pages/automation-rule/form/actions';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import { triggerTypes, useAutomationRuleTrigger } from 'src/pages/automation-rule/form/trigger/use-trigger';
import { randomStringGenerator } from 'src/pages/automation-rule/form/utils/random-string-generator';

export function useResolveChildrenWhenParentIsResolved() {
	const { setTitle } = useAutomationRuleFormProvider();
	const { setTrigger, setTriggerData } = useAutomationRuleTrigger();
	const { setActions} = useAutomationRuleActions();
  
	const resolveChildrenWhenParentIsResolved = useCallback(() => {
		setTitle('When parent is resolved, then resolved all child work items');
		setTrigger(triggerTypes.workItemTransitions);
		setTriggerData({
			workItemTransitions: {
				selectedFrom: ['any'],
				selectedTo: ['Done'],
				loading: true,
			},
			workItemIsAssignedTo: null,
			fieldValueChange: null,
			checklistTrigger: null
		});
		setActions([
			{
				id: randomStringGenerator(),
				action: actionTypes.editWorkItem,
				editWorkItem: {
					workItemField: 'System.State',
					relationship: 'children-work-items',
					inputValueType: 'select',
					selectValue: ['Done'],
					textValue: '',
					dateTimeValue: {
						type: 'datetime',
						datetime: {
							value: new Date(),
						},
						timeframe: {
							timeNumber: 0,
							timeUnit: 'minutes',
							timeOption: 'ago'
						}
					},
					userFieldValue: [],
					iterationOrAreaPathValue: '',
					copyFieldValue: '',
					fieldActionValue: 'set-value'
				},
				addCommentToWorkItem: null,
				sendNotificationToSlack: null,
				sendEmailNotification: null,
				sendTeamsNotification: null,
				createdAt: new Date()
			},
		]);
	}, []);

	return {
		resolveChildrenWhenParentIsResolved,
	};
}